import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzafrvp4mp: FaireProductEntity = {
  token: "p_kzafrvp4mp",
  type: "product",
  name: "Bunch of Cats Red Porcelain Yunomi Tea Cup – 10 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/c1ed6fe2bbb4c89f24b5f36215cd8db379c7d0a332da3e50eaae38415311b1f8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a5d016137540dbc2b4744b57ebecc1a71c8e079a7ee88c69b8e291fbc1eead5.jpeg",
    "https://cdn.faire.com/fastly/3fc51b8546e472a98acad68f27ed58b66ee3d522a0aec89dba54a95c23982b57.jpeg",
    "https://cdn.faire.com/fastly/f9b3382191efd3e0a369d1ed704397b4d20656193cf0aad18386be440fb23b39.jpeg"
  ],
  priceDollars: 5.5,
  description: "Serve hot green tea the Japanese way with this 10 oz yunomi tea cup in Bunch of Cats Red. It is decorated with a playful bunch of cats in red. Made in Japan from durable porcelain, it is built for sushi bars, ramen shops, cafés and Japanese restaurants, while looking just as good at home. A thoughtful gift for tea lovers and cat fans.\n\nFeatures\n\n * Classic yunomi shape: a tall, handleless cup that is comfortable to hold with both hands \n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 2.75\" Dia x 4\" H \n * Capacity: 10 fl oz \n * Material: Porcelain \n * Design: Bunch of Cats Red \n * Inner pack: 6 \n * Case pack: 60 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:57.159Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
